(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const footerBlocks = document.querySelectorAll('.footer__block');

    footerBlocks.forEach(block => {
        const header = block.querySelector('.link_header');
        const blockList = block.querySelector('.v-stack');

        if (header && blockList) {
            header.addEventListener('click', function() {
                blockList.classList.toggle('active');
                header.classList.toggle('active');
            });
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const today = new Date();
  let day = today.getDay();
  const workDaysToAdd = 2;
  let addedDays = 0;
  
  // Function to check if a day is a working day (Monday to Friday)
  const isWorkingDay = (day) => day >= 1 && day <= 5;
  
  while (addedDays < workDaysToAdd) {
    today.setDate(today.getDate() + 1);
    day = today.getDay();
    if (isWorkingDay(day)) {
      addedDays++;
    }
  }
  
  const estimatedDateFrom = today.toLocaleDateString('da-DK', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  // Add one more working day to get the range for the delivery date
  addedDays = 0;
  while (addedDays < 1) {
    today.setDate(today.getDate() + 1);
    day = today.getDay();
    if (isWorkingDay(day)) {
      addedDays++;
    }
  }
  
  const estimatedDateTo = today.toLocaleDateString('da-DK', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  const estimatedDeliveryText = `${estimatedDateFrom} - ${estimatedDateTo}`;
  document.querySelector('.estimated-date').innerHTML = estimatedDeliveryText;



    // Sticky Variant
    // document.addEventListener('DOMContentLoaded', function() {
    //     document.querySelectorAll('.block-swatch').forEach(function(swatch) {
    //         swatch.addEventListener('click', function() {
    //             var value = this.getAttribute('value');
    //             document.querySelectorAll('.sticky_variant input[type="radio"]').forEach(function(radio) {
    //                 radio.checked = false;
    //             });
    //             document.querySelector('.pro_variant label[value="' + value + '"]').click();
    //             document.querySelector('.sticky_variant input[type="radio"][value="' + value + '"]').checked = true;
    //         });
    //     });
    // });
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.block-swatch').forEach(function(swatch) {
            swatch.addEventListener('click', function() {
                var value = this.getAttribute('value');

                var inputName = this.previousElementSibling.getAttribute('name');

                // Uncheck all radios in the same variant group
                document.querySelectorAll('.sticky_variant input[type="radio"][name="' + inputName + '"]').forEach(function(radio) {
                  radio.checked = false;
                });
    
                // Temporarily disable scrolling
                var originalScrollPosition = window.scrollY;
                var scrollHandler = function() {
                    window.scrollTo(0, originalScrollPosition);
                };
                window.addEventListener('scroll', scrollHandler);
    
                // Trigger the click event on the label
                document.querySelector('.pro_variant label[value="' + value + '"]').click();
    
                // Re-enable scrolling
                window.setTimeout(function() {
                    window.removeEventListener('scroll', scrollHandler);
                }, 0);
    
                // Check the corresponding radio button in sticky_variant
                document.querySelector('.sticky_variant input[type="radio"][name="' + inputName + '"][value="' + value + '"]').checked = true;
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile_menu_drawer"] && !window.DesignMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {
    const menuDrawer = document.querySelector('#shopify-section-mobile_menu_drawer ul');
    const panelScroller = document.querySelector('.panel__scroller');

    if (menuDrawer && panelScroller) {
      menuDrawer.style.display = 'block';
      panelScroller.appendChild(menuDrawer);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
